module.exports = __webpack_public_path__ + "static/media/db.4d993512.png";